import initBentoFeatures from "../modules/bento-features.js";

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initBentoFeatures);
} else {
  initBentoFeatures();
}
